import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=2d106042&"
import script from "./EditItem.vue?vue&type=script&lang=js&"
export * from "./EditItem.vue?vue&type=script&lang=js&"
import style0 from "./EditItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports